<template>
  <div>
    <div id="iFrameContainer" class="pbiReportContainer" :key="brand"></div>
  </div>
</template>

<script>
/*global powerbi*/
import _ from 'lodash';
import http from '@/mixins/http';
import * as pbi from 'powerbi-client'; // eslint-disable-line no-unused-vars
const _brands = () => {
  return ['All', 'F1', 'T1', 'R1', 'P1', 'J1'];
};

export default {
  name: 'PbiReportViewer',
  props: {
    powerBiEmbedUrlId: { type: [String], required: true },
    brand: {
      type: String,
      required: true,
      validator(value) {
        return _brands().includes(value);
      },
    },
  },
  mixins: [http],
  mounted() {
    if (this.powerBiEmbedUrlId && this.brand) this.loadReport();
  },
  watch: {
    powerBiEmbedUrlId() {
      if (this.powerBiEmbedUrlId && this.brand) this.loadReport();
    },
    brand() {
      if (this.powerBiEmbedUrlId && this.brand) this.getToken();
    },
  },
  data() {
    return {
      report: null,
      token: null,
      embedUrlMappings: null,
    };
  },
  methods: {
    getEmbedUrls() {
      let path = '/api/businessDashboard/EmbedUrls';
      if(this.brand !== 'All')
        path = '/api/dashboard/EmbedUrls'
      this.axios.get(path).then(resp => {
        if (resp.data) {
          this.embedUrlMappings = resp.data;
          this.loadReport();
        }
      });
    },
    getToken() {
      const handler = resp => {
        if (resp.data) {
          this.token = resp.data;
          this.loadReport();
        }
      };
      const code = _brands().indexOf(this.brand);
      if (code > 0) {
        this.axios
          .get('/api/dashboard/AccessToken', { params: { account: code } })
          .then(handler);
      } else if (code === 0) {
        this.axios.get('/api/businessDashboard/AccessToken').then(handler);
      }
    },
    loadReport() {
      if (!this.embedUrlMappings) {
        this.getEmbedUrls();
        return;
      }
      const embedUrl =
        _.find(this.embedUrlMappings, {
          powerBiEmbedUrlId: this.powerBiEmbedUrlId,
        })?.embedUrl || '';

      if (embedUrl) {
        if (!this.token) {
          this.getToken();
          return;
        }
        const token = this.token;

        const container = document.getElementById('iFrameContainer');
        let embedConfiguration = {
          type: 'report',
          embedUrl: embedUrl,
          accessToken: token,
        };
        const report = powerbi.embed(container, embedConfiguration);
        report.off('loaded');
        report.on('loaded', event => {
          // eslint-disable-next-line no-console
          console.log('report loaded ', event);
        });

        this.report = report;
      }
    },
  },
};
</script>

<style scoped></style>